import React from 'react';
import { Header } from './Header';
import { Hero } from './Hero';
import { HeroDetails } from './HeroDetails';
import { LogoSection } from './LogoSection';
import { WhatAreConstellations } from './WhatAreConstellations';
import { TalleresIntro } from './TalleresIntro';
import { WorkshopExperience } from './WorkshopExperience';
import { Benefits } from './Benefits';
import { ForYouSection } from './ForYouSection';
import { WhereSection } from './WhereSection';
import { RetreatsSection } from './RetreatsSection';
import { AboutMeSection } from './AboutMeSection';
import { ContactSection } from './ContactSection';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { FloatingButtons } from './FloatingButtons';
export function HomePage() {
  return <>
      <Header data-id="element-459" />
      <main data-id="element-460">
        <Hero data-id="element-461" />
        <HeroDetails data-id="element-462" />
        <TalleresIntro data-id="element-463" />
        <WorkshopExperience data-id="element-464" />
        <Benefits data-id="element-465" />
        <ForYouSection data-id="element-466" />
        <FinalCTA data-id="element-467" />
        <WhatAreConstellations data-id="element-468" />
        <WhereSection data-id="element-469" />
        <RetreatsSection data-id="element-470" />
        <AboutMeSection data-id="element-471" />
        <ContactSection data-id="element-472" />
      </main>
      <Footer data-id="element-473" />
      <FloatingButtons data-id="element-474" />
    </>;
}